import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { DELETED_USERS } from "../../Action/actionTypes";
import { deletedUsersFailure, deletedUsersSuccess } from "../../Action";
import { getLocalStorageItem } from "../../../Utils/Helper";

function* getDeletedusersDetails(action) {
    try {

        const { currentPage, rowCount,whitelabelID } = action?.payload?.payload
      
    
        const { data } = yield API.get(`/deletedusersList?currentPage=${currentPage}&rowCount=${rowCount}&whiteLabelId=${whitelabelID}`);


        if (action?.payload?.callback) {
            yield call(action.payload.callback, data);
        }
       
        if (data?.meta?.code === 200) {
            yield put(deletedUsersSuccess(data?.data));

            if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
        } else {

            yield put(deletedUsersFailure());
        }
    } catch (error) {
        yield put(deletedUsersFailure(error.message));

    }
}

export function* watchGetWhitelabelAPI() {
    yield takeEvery(DELETED_USERS, getDeletedusersDetails);
}

export default function* rootSaga() {
    yield all([watchGetWhitelabelAPI()]);
}
